import './index.css';
const useButton = ({ disabled, Element = 'button', }) => {
    let additionalAttributes = {};
    if (Element === 'button') {
        additionalAttributes = {};
    }
    else {
        additionalAttributes = {
            role: 'button',
            tabIndex: disabled ? undefined : 0,
            'aria-disabled': disabled,
        };
    }
    return {
        ariaProps: additionalAttributes,
    };
};

export { useButton };
//# sourceMappingURL=aria.js.map
